"use client";

import { useEffect, useState } from "react";
import { DiscountHandler } from "~/components/discount-handler";
import { ProgressBarWrapper } from "~/components/providers/progress-bar-wrapper";

export function ClientOnlyProviders() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <>
      {isMounted ? <DiscountHandler /> : null}
      <ProgressBarWrapper />
    </>
  );
}
